import { BasicContent } from './BasicContent';
import RichText from './RichText';
import ParocCo2Calculator from '../../composites/Paroc/ParocCo2Calculator';

const CMSParocCo2Calculator = ({ ...content }) => (
  <>
    <BasicContent {...content.copy} />
    <ParocCo2Calculator />
    <RichText content={content.footnotes} />
  </>
);

export default CMSParocCo2Calculator;
